module.exports = __webpack_public_path__ + "static/media/hot-top-right.c19b7b22.svg";